import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js"

const escapeHtml = (value) =>
  String(value).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]))

// Small "PNG herunterladen" / "Einbetten" links rendered under a CMS chart.
// Finds the nearest preceding chart canvas, exports it as PNG or copies an iframe embed snippet.
export default class extends Controller {
  static targets = ["embedFeedback"]
  static values = {
    filename: String,
    embedUrl: String,
    articleUrl: String,
    title: String
  }

  download(event) {
    event.preventDefault()
    const canvas = this.findCanvas()
    if (!canvas) return

    const chart = Chart.getChart(canvas)
    const dataUrl = chart ? this.exportWithWhiteBackground(chart) : canvas.toDataURL("image/png")
    const link = document.createElement("a")
    link.href = dataUrl
    link.download = `${this.filenameValue || "pflegehelfer24-grafik"}.png`
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  async embed(event) {
    event.preventDefault()
    const snippet = this.embedSnippet()
    try {
      await navigator.clipboard.writeText(snippet)
      this.flash("Embed-Code kopiert")
    } catch (_e) {
      window.prompt("Embed-Code kopieren:", snippet)
    }
  }

  embedSnippet() {
    const title = escapeHtml(this.titleValue || "Grafik")
    const embedUrl = escapeHtml(this.embedUrlValue)
    const articleUrl = escapeHtml(this.articleUrlValue)
    return [
      `<iframe src="${embedUrl}" title="${title} – PflegeHelfer24" width="100%" height="560" style="border:0;max-width:800px" loading="lazy"></iframe>`,
      `<p style="font-size:12px">Quelle: <a href="${articleUrl}">PflegeHelfer24 – ${title}</a></p>`
    ].join("\n")
  }

  // Chart.js canvases are transparent; journalists need a white background.
  exportWithWhiteBackground(chart) {
    const source = chart.canvas
    const out = document.createElement("canvas")
    out.width = source.width
    out.height = source.height
    const ctx = out.getContext("2d")
    ctx.fillStyle = "#ffffff"
    ctx.fillRect(0, 0, out.width, out.height)
    ctx.drawImage(source, 0, 0)
    return out.toDataURL("image/png")
  }

  findCanvas() {
    let element = this.element.previousElementSibling
    while (element) {
      const canvas = element.querySelector("canvas")
      if (canvas) return canvas
      element = element.previousElementSibling
    }
    return this.element.parentElement?.querySelector("canvas") || null
  }

  flash(text) {
    if (!this.hasEmbedFeedbackTarget) return
    this.embedFeedbackTarget.textContent = text
    this.embedFeedbackTarget.classList.remove("hidden")
    clearTimeout(this.flashTimer)
    this.flashTimer = setTimeout(() => this.embedFeedbackTarget.classList.add("hidden"), 2500)
  }
}
